module.exports = __webpack_public_path__ + "static/media/prev.64a33862.svg";